import './Loader.scss';

export const Loader = () => (
  <div className="Loader">
    <div className="Loader__content" />
  </div>
);
